import { Icon, type IconPropsWithoutChildren } from "@components/icon"
import MuiBroadcastOnHomeIcon from "@mui/icons-material/BroadcastOnHome"

export function BroadcastOnHomeIcon(props: IconPropsWithoutChildren) {
	return (
		<Icon {...props}>
			<MuiBroadcastOnHomeIcon fontSize="inherit" />
		</Icon>
	)
}
